import {
    Box,
    Button,
    Card,
    Grid,
    makeStyles,
    Paper,
    Typography,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    Divider,
    TablePagination,
    Tooltip,
    Chip,
    Popover,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Spinner } from '../../components/UI';
import {
    fetchAppConfig,
    setIgnoreDateFilter,
    setBulkReleaseFlag,
    setSelectedPayments,
    getSourceSystemsList,
    setFilterModalConfig,
    getAllPaymentIndentsListingData,
    getPaymentBroker,
    updatePaymentBroker,
    getAxisBankBalance,
} from '../../store/actions/authActionCreator';
import AllPaymentIndentsListContainer from '../../components/Containers/AllPaymentIndentsListContainer';
import Searchbar from '../../components/Searchbar';
import ComboViewModal from '../../components/Modals/Zappay/ComboViewModal';
import ConfirmModal from '../../components/Modals/ConfirmModal';
import FilterListRoundedIcon from '@material-ui/icons/FilterListRounded';
import GetAppIcon from '@material-ui/icons/GetApp';
import UploadPaymentModal from '../../components/Modals/Zappay/UploadPaymentModal';
import BulkReleaseModal from '../../components/Modals/Zappay/BulkReleaseModal';
import moment from 'moment';
import {
    formatCurrency,
    getPermissions,
    JSONToCSVConvertor,
    replaceTextWithCapsAndUnderscore,
    showMessage,
} from '../../utils/helper';
import CachedIcon from '@material-ui/icons/Cached';
import { useDebounce } from '../../hooks/useDebounce';
import {
    PAYMENT_INDENT_DATE_RANGE_LIMIT_DAYS,
    PaymentBrokers,
} from '../../utils/constants';

const PINCODE_SOURCE_SYSTEM_NAME = 'Pincode';

const useStyles = makeStyles((theme) => ({
    horizontalCardContents: {
        display: 'flex',
        flexDirection: 'row',
        margin: '16px 0',
        flexWrap: 'wrap',
    },
    searchBar: {
        width: '50%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
    },
    verticalCardContents: {
        flex: '1 1 20%',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        justifyContent: 'center',
        border: 'solid 1px #ebedf8',
        borderRadius: '8px',
        backgroundColor: '#ebedf8',
        paddingLeft: '16px',
        height: '88px',
        margin: '0 8px 0 0 ',
    },
    verticalCardContentsActive: {
        backgroundColor: '#d1d8ff',
    },
    verticalCardContentsNoMargin: {
        margin: 0,
    },
    cardSubHeader: {
        fontSize: '22px',
        fontWeight: 700,
    },
    cardHeader: {
        fontSize: '16px',
        fontWeight: 600,
    },
    chipRoot: {
        marginRight: 4,
        height: '100%',
        paddingLeft: 10,
        background: '#d1d8ff',
        color: 'black',
        '& .MuiChip-label': {
            fontWeight: 600,
            width: 'auto !important',
            fontSize: '16px !important',
        },
        '& .MuiChip-deleteIcon': {
            margin: 4,
        },
    },
    chipRootNoDelete: {
        // height: '100%',
        marginRight: 8,
        padding: '0 12px',
        background: '#d1d8ff',
        color: 'black',
        '& .MuiChip-label': {
            fontWeight: 600,
            width: 'auto !important',
            fontSize: '16px !important',
        },
    },
}));

const FILTER_STATUS = Object.freeze({
    PENDING_AMOUNT: 'PENDING_AMOUNT',
    INPROGRESS_TRANSACTIONS: 'INPROGRESS_TRANSACTIONS',
    FAILED_TRANSACTIONS: 'FAILED_TRANSACTIONS',
});

function PayOnline({
    configs,
    user,
    dispatchFetchAppConfig,
    dispatchSetIgnoreDateFilter,
    dispatchSetBulkReleaseFlag,
    dispatchSetSelectedPaymentData,
    dispatchGetSourceSystemsList,
    dispatchSetFilterModalConfig,
    dispatchGetAllPaymentIndentsListingData,
    dispatchGetPaymentBroker,
    dispatchUpdatePaymentBroker,
    dispatchGetAxisBankBalance,
    staff = {},
    ...props
}) {
    const { debounce, isBouncing } = useDebounce();
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [brokerSwitchModalOpen, setBrokerSwitchModalOpen] = useState(false);
    const [brokerPopoverAnchor, setBrokerPopoverAnchor] = useState(null);

    const [searchedValue, setSearchedValue] = useState('');
    const [activeCard, setActiveCard] = useState(0);

    const [comboViewModalOpen, setComboViewModalOpen] = useState(false);
    // const [bulkReleaseModal, setBulkReleaseModal] = useState(false);
    const [paymentModalOpen, setPaymentModalOpen] = useState(false);

    const [defaultSourceSystem, setDefaultSourceSystem] = useState(
        user?.zappay?.filterGroupModalConfig?.sourceSystem,
    );

    const [paymentIndentListingData, setPaymentIndentListingData] = useState(
        user?.zappay?.listingData?.lineItems ?? [],
    );

    const [filteredListingData, setFilteredListingData] = useState(
        user?.zappay?.listingData?.lineItems ?? [],
    );

    const [permissions, setPermissions] = useState(
        getPermissions('pay_online'),
    );

    useEffect(() => {
        setPaymentIndentListingData(user?.zappay?.listingData?.lineItems);
        setFilteredListingData(user?.zappay?.listingData?.lineItems);
    }, [user?.zappay?.listingData]);

    useEffect(() => {
        console.log('paymentIndentListingData', paymentIndentListingData);
        // dispatchSetSelectedPaymentData([]);
    }, [paymentIndentListingData]);

    useEffect(() => {
        dispatchFetchAppConfig(
            (resp) => {
                if (resp?.status?.code == 200) {
                    console.log('defaultSourceSystem', defaultSourceSystem);
                    let sourceSys =
                        user?.zappay?.filterGroupModalConfig?.sourceSystem ??
                        null;

                    if (!sourceSys) {
                        dispatchGetSourceSystemsList(
                            {},
                            (resp) => {
                                console.log(
                                    'SOURCE SYSTEM LIST Success',
                                    resp?.response?.sourceSystems,
                                );
                                let filteredDefaultSourceSystem =
                                    resp?.response?.sourceSystems?.filter(
                                        (item) => item.default,
                                    );
                                setDefaultSourceSystem(
                                    filteredDefaultSourceSystem[0],
                                );
                                sourceSys = filteredDefaultSourceSystem[0];

                                let initialFilterModalConfig = {
                                    dateRange: {
                                        startTimeEpochMillis: moment()
                                            .subtract(
                                                PAYMENT_INDENT_DATE_RANGE_LIMIT_DAYS,
                                                'days',
                                            )
                                            .startOf('day')
                                            .valueOf(),
                                        endTimeEpochMillis: moment()
                                            .endOf('day')
                                            .valueOf(),
                                    },
                                    sourceSystem: sourceSys,
                                    filters: {},
                                    paymentStatus: 'Ready For Payment',
                                };

                                console.log(
                                    'initialFilterModalConfig',
                                    initialFilterModalConfig,
                                );

                                dispatchSetFilterModalConfig(
                                    initialFilterModalConfig,
                                    () => {
                                        console.log(
                                            'dispatchSetFilterModalConfig success',
                                        );
                                    },
                                    () => {
                                        console.log(
                                            'dispatchSetFilterModalConfig failed',
                                        );
                                    },
                                );
                            },
                            (err) => {
                                console.log('SOURCE SYSTEM LIST failed', err);
                            },
                        );
                    }
                }
            },
            () => {},
        );
        console.log('permsss', permissions);
        return () => {
            // dispatchSetSelectedPaymentData([]);
        };
    }, []);

    // useEffect(() => {
    //     // dispatchFetchAppConfig();
    //     if (
    //         defaultSourceSystem != null &&
    //         Object.keys(defaultSourceSystem).length != 0
    //     ) {
    //         console.log('defaultSourceSystem', defaultSourceSystem);

    //         let listingRequestPayload = {
    //             dateRange: {
    //                 startTimeEpochMillis: moment()
    //                     .add(-1, 'months')
    //                     .startOf('month')
    //                     .valueOf(),
    //                 endTimeEpochMillis: moment().endOf('month').valueOf(),
    //             },
    //             filters: {},
    //             sourceSystemId: defaultSourceSystem?.id,
    //         };
    //         console.log('listingRequestPayload payload', listingRequestPayload);

    //         let initialFilterModalConfig = {
    //             ...user?.zappay?.filterGroupModalConfig,
    //             dateRange: {
    //                 startTimeEpochMillis: moment()
    //                     .add(-1, 'months')
    //                     .startOf('month')
    //                     .valueOf(),
    //                 endTimeEpochMillis: moment().endOf('month').valueOf(),
    //             },
    //             sourceSystem: defaultSourceSystem,
    //             filters: {},
    //             paymentStatus: 'All',
    //         };

    //         console.log('initialFilterModalConfig', initialFilterModalConfig);

    //         dispatchSetFilterModalConfig(
    //             initialFilterModalConfig,
    //             () => {
    //                 console.log('dispatchSetFilterModalConfig success');
    //             },
    //             () => {
    //                 console.log('dispatchSetFilterModalConfig failed');
    //             },
    //         );
    //     }
    // }, []);

    function fetchListingData(overrideConfig = null) {
        const config =
            overrideConfig ?? user?.zappay?.filterGroupModalConfig;

        if (config == null || Object.entries(config).length == 0) {
            showMessage(
                'Please apply filters before fetching data',
                'error',
            );
            return;
        }

        let selectedIgnoreDataFilters = Object.entries(
            config?.filters ?? {},
        )?.filter((selectedFilter) =>
            user?.zappay?.sourceSystemFilterListData
                ?.filter((item) => item?.ignoreDateFilter == true)
                ?.map((selected) => selected?.key)
                ?.includes(selectedFilter[0]),
        );

        const dateRangeMissing =
            !config?.dateRange?.startTimeEpochMillis ||
            !config?.dateRange?.endTimeEpochMillis;

        if (!(selectedIgnoreDataFilters?.length > 0) && dateRangeMissing) {
            showMessage(
                'Please select a date range to proceed',
                'error',
            );
            return;
        }

        if (selectedIgnoreDataFilters?.length > 0) {
            dispatchSetIgnoreDateFilter(true);
        } else {
            dispatchSetIgnoreDateFilter(false);
        }

        let listingRequestPayload =
            selectedIgnoreDataFilters?.length > 0
                ? {
                      filters: config?.filters ?? {},
                      sourceSystemId: config?.sourceSystem?.id,
                      paymentStatus:
                          'ALL' ==
                          config?.paymentStatus.toUpperCase()
                              ? null
                              : replaceTextWithCapsAndUnderscore(
                                    config?.paymentStatus,
                                ),
                  }
                : {
                      dateRange: config?.dateRange,
                      filters: config?.filters ?? {},
                      sourceSystemId: config?.sourceSystem?.id,
                      paymentStatus:
                          'ALL' ==
                          config?.paymentStatus.toUpperCase()
                              ? null
                              : replaceTextWithCapsAndUnderscore(
                                    config?.paymentStatus,
                                ),
                  };

        if (config?.sourceSystem?.id) {
            dispatchGetPaymentBroker({ id: config?.sourceSystem?.id });
        }

        setLoading(true);
        dispatchGetAllPaymentIndentsListingData(
            listingRequestPayload ?? {},
            (resp) => {
                setLoading(false);
            },
            () => {
                setLoading(false);
            },
        );
    }

    const activeSourceSystem =
        user?.zappay?.filterGroupModalConfig?.sourceSystem;
    const activeBroker = user?.zappay?.activeBroker;

    useEffect(() => {
        if (activeSourceSystem?.id) {
            dispatchGetPaymentBroker({ id: activeSourceSystem?.id });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeSourceSystem?.id]);

    useEffect(() => {
        if (activeBroker === PaymentBrokers.AXIS_BANK) {
            dispatchGetAxisBankBalance();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeBroker]);
    const canSwitchBroker =
        activeSourceSystem?.name &&
        activeSourceSystem?.name?.toLowerCase() !==
            PINCODE_SOURCE_SYSTEM_NAME.toLowerCase();
    const otherBroker =
        activeBroker === PaymentBrokers.CASHFREE
            ? PaymentBrokers.AXIS_BANK
            : PaymentBrokers.CASHFREE;
    const formatBrokerLabel = (broker) => broker?.replace(/_/g, ' ');

    const handleSwitchBroker = (toggleLoading) => {
        dispatchUpdatePaymentBroker(
            { id: activeSourceSystem?.id, broker: otherBroker },
            () => {
                dispatchGetPaymentBroker({ id: activeSourceSystem?.id });
                toggleLoading(false);
                setBrokerSwitchModalOpen(false);
            },
            (error) => {
                toggleLoading(false);
                if (error?.status === 500 || error?.code === 500) {
                    showMessage(
                        'Vendor configuration missing — contact backend team',
                        'error',
                    );
                }
            },
        );
    };

    function getListingDataWithFilterParam(paymentFilterStatus) {
        let tempData = [...paymentIndentListingData];

        if (paymentFilterStatus == 'PENDING') {
            tempData = tempData?.filter(
                (data) => data?.paymentStatus != 'RELEASED',
            );
        }
        if (paymentFilterStatus == 'IN_PROGRESS') {
            tempData = tempData?.filter(
                (data) => data?.paymentStatus == 'IN_PROGRESS',
            );
        }
        if (paymentFilterStatus == 'FAILED') {
            tempData = tempData?.filter(
                (data) => data?.paymentStatus == 'FAILED',
            );
        }
        setFilteredListingData(tempData);
    }

    function searchData(data) {
        if (searchedValue) {
            return data?.filter((val) =>
                val?.accountName
                    ?.toLowerCase()
                    .includes(searchedValue?.toLowerCase()),
            );
        } else {
            return data;
        }
    }

    return (
        <Spinner loading={loading}>
            {true ? (
                <Paper style={{ padding: '12px' }} elevation={0}>
                    <Box
                        style={{
                            margin: '4px 0',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                        >
                            <Box
                                style={{
                                    width: '400px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                }}
                            >
                                <Searchbar
                                    placeHolderText="Search Account Name, UTR"
                                    value={searchedValue}
                                    keys={['name', 'hubName']}
                                    onFilter={async (filteredData) => {}}
                                    onChange={(value) => {
                                        console.log('blur', value);
                                        setSearchedValue(value);
                                    }}
                                />
                            </Box>

                            <Tooltip title="Download Report" placement="top">
                                <IconButton
                                    className={'inputbutton'}
                                    variant="outlined"
                                    style={{
                                        marginLeft: 10,
                                        marginRight: 10,
                                        border: '1px solid #43419e',
                                        borderRadius: 8,
                                        padding: 6,
                                    }}
                                    color="primary"
                                    onClick={(e) => {
                                        debounce(() => {
                                            let paymentIndentReportData = [];

                                            filteredListingData?.forEach(
                                                (item) => {
                                                    let sourceSystemFiltersKeyList =
                                                        user?.zappay?.sourceSystemFilterListData?.map(
                                                            (item) => item?.key,
                                                        );
                                                    let arrayItem = {
                                                        'Reference ID':
                                                            item?.referenceId,
                                                        'Source Sytem':
                                                            user?.zappay
                                                                ?.filterGroupModalConfig
                                                                ?.sourceSystem
                                                                ?.name,
                                                        'Account Name':
                                                            item?.accountName,
                                                    };

                                                    user?.zappay?.listingData
                                                        ?.metaDataDisplayNameMappings &&
                                                        Object.entries(
                                                            user?.zappay
                                                                ?.listingData
                                                                ?.metaDataDisplayNameMappings,
                                                        )?.forEach(
                                                            (keyVal, index) => {
                                                                let key =
                                                                    keyVal[0];
                                                                let val =
                                                                    keyVal[1];
                                                                if (
                                                                    sourceSystemFiltersKeyList?.includes(
                                                                        key,
                                                                    )
                                                                ) {
                                                                    arrayItem =
                                                                        {
                                                                            ...arrayItem,
                                                                            [val]: item
                                                                                ?.metaData[
                                                                                key
                                                                            ],
                                                                        };
                                                                }
                                                            },
                                                        );

                                                    arrayItem = {
                                                        ...arrayItem,
                                                        Amount: item?.amount,
                                                        'UTR Number':
                                                            item?.utrNumber ??
                                                            '',
                                                        'Payment Status':
                                                            item?.paymentStatus,
                                                        'Payment Vendor':
                                                            item?.paymentVendor ??
                                                            '',
                                                        'UPI Address':
                                                            item?.upiAddress,
                                                        IFSC: item?.ifscCode,
                                                        'Account Number':
                                                            item?.accountNumber,
                                                        'Account Name':
                                                            item?.accountName,
                                                        'Bank Name':
                                                            item?.bankName ??
                                                            '',
                                                        'Payment Date':
                                                            item?.expectedPaymentDate,
                                                    };

                                                    user?.zappay?.listingData
                                                        ?.metaDataDisplayNameMappings &&
                                                        Object.entries(
                                                            user?.zappay
                                                                ?.listingData
                                                                ?.metaDataDisplayNameMappings,
                                                        )?.forEach(
                                                            (keyVal, index) => {
                                                                let key =
                                                                    keyVal[0];
                                                                let val =
                                                                    keyVal[1];

                                                                if (
                                                                    !sourceSystemFiltersKeyList?.includes(
                                                                        key,
                                                                    )
                                                                ) {
                                                                    arrayItem =
                                                                        {
                                                                            ...arrayItem,
                                                                            [val]: item
                                                                                ?.metaData[
                                                                                key
                                                                            ],
                                                                        };
                                                                }
                                                            },
                                                        );
                                                    arrayItem = {
                                                        ...arrayItem,
                                                        'Vendor Transfer ID':
                                                            item?.vendorTransferId ??
                                                            '',
                                                    };
                                                    paymentIndentReportData.push(
                                                        arrayItem,
                                                    );
                                                },
                                            );
                                            JSONToCSVConvertor(
                                                'Payment Indent Report',
                                                paymentIndentReportData,
                                                'Payment Indent Report',
                                                true,
                                            );
                                        });
                                    }}
                                    disabled={
                                        isBouncing ||
                                        !paymentIndentListingData?.length ||
                                        !permissions?.read
                                    }
                                >
                                    <GetAppIcon size="small" />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Reload" placement="top">
                                <IconButton
                                    style={{}}
                                    onClick={() => {
                                        setActiveCard(0);
                                        dispatchSetBulkReleaseFlag(false);
                                        fetchListingData();
                                    }}
                                >
                                    <CachedIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Box
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                        >
                            {activeBroker && canSwitchBroker && (
                                <Box
                                    onClick={(e) => {
                                        setBrokerPopoverAnchor(
                                            e.currentTarget,
                                        );
                                        dispatchGetPaymentBroker({
                                            id: activeSourceSystem?.id,
                                        });
                                    }}
                                    style={{
                                        backgroundColor: '#ebedf8',
                                        borderRadius: 8,
                                        marginRight: 8,
                                        padding: '0 16px 0 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: 'center',
                                            fontWeight: 700,
                                        }}
                                    >
                                        Payment Vendor
                                    </Typography>
                                    <Box
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: 'center',
                                                fontWeight: 600,
                                                color: '#43419e',
                                            }}
                                        >
                                            {formatBrokerLabel(activeBroker)}
                                        </Typography>
                                        <ArrowDropDownIcon
                                            fontSize="small"
                                            style={{ color: '#43419e' }}
                                        />
                                    </Box>
                                </Box>
                            )}
                            <Popover
                                open={Boolean(brokerPopoverAnchor)}
                                anchorEl={brokerPopoverAnchor}
                                onClose={() => setBrokerPopoverAnchor(null)}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                            >
                                <Box style={{ padding: 12 }}>
                                    <Button
                                        size="small"
                                        color="primary"
                                        onClick={() => {
                                            setBrokerPopoverAnchor(null);
                                            setBrokerSwitchModalOpen(true);
                                        }}
                                        style={{
                                            textTransform: 'none',
                                            fontWeight: 600,
                                        }}
                                    >
                                        {`Switch to ${formatBrokerLabel(otherBroker)}`}
                                    </Button>
                                </Box>
                            </Popover>
                            <Box
                                style={{
                                    backgroundColor: '#ebedf8',
                                    borderRadius: 8,
                                    marginRight: 8,
                                    padding: '0 16px 0 16px',
                                }}
                            >
                                <Typography
                                    style={{
                                        textAlign: 'center',
                                        fontWeight: 700,
                                        // color: '#43419E',
                                    }}
                                >
                                    Available Balance
                                </Typography>
                                <Typography
                                    style={{
                                        textAlign: 'center',
                                        fontWeight: 600,
                                        color: '#4caf50',
                                    }}
                                >
                                    {formatCurrency(
                                        activeBroker ===
                                            PaymentBrokers.AXIS_BANK
                                            ? user?.zappay?.axisBalance
                                                  ?.availableBalance
                                            : user?.zappay?.listingData
                                                  ?.availableBalance,
                                    )}
                                </Typography>
                            </Box>
                            <Box>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="btn-pos"
                                    onClick={() => {
                                        setPaymentModalOpen(true);
                                    }}
                                    style={{
                                        height: '100%',
                                        padding: '0 12px',
                                        fontWeight: 600,
                                    }}
                                    disabled={!permissions.create}
                                    disableElevation
                                >
                                    Upload Payments
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                    <Box className={classes.horizontalCardContents}>
                        <Box
                            className={`${classes.verticalCardContents} ${
                                activeCard === 0 &&
                                classes.verticalCardContentsActive
                            }`}
                            onClick={() => {
                                setActiveCard(0);
                                getListingDataWithFilterParam(null);
                            }}
                        >
                            <Typography className={classes.cardHeader}>
                                Total Amount
                            </Typography>
                            <Typography className={classes.cardSubHeader}>
                                {/* {attendanceAll.totalCount} */}
                                {formatCurrency(
                                    user?.zappay?.listingData?.totalAmount,
                                )}
                            </Typography>
                        </Box>
                        <Box
                            className={`${classes.verticalCardContents} ${
                                activeCard === FILTER_STATUS.PENDING_AMOUNT &&
                                classes.verticalCardContentsActive
                            }`}
                            onClick={() => {
                                setActiveCard('PENDING_AMOUNT');
                                getListingDataWithFilterParam('PENDING');
                            }}
                        >
                            <Typography className={classes.cardHeader}>
                                Pending Amount
                            </Typography>
                            <Typography className={classes.cardSubHeader}>
                                {/* {attendanceAll.presentCount} */}
                                {formatCurrency(
                                    user?.zappay?.listingData?.pendingAmount,
                                )}
                            </Typography>
                        </Box>
                        <Box
                            className={`${classes.verticalCardContents} ${
                                activeCard ===
                                    FILTER_STATUS.FAILED_TRANSACTIONS &&
                                classes.verticalCardContentsActive
                            }`}
                            onClick={() => {
                                setActiveCard('FAILED_TRANSACTIONS');
                                getListingDataWithFilterParam('FAILED');
                            }}
                        >
                            <Typography className={classes.cardHeader}>
                                Failed Transactions
                            </Typography>
                            <Typography className={classes.cardSubHeader}>
                                {user?.zappay?.listingData?.failedTransactions}
                            </Typography>
                        </Box>
                        <Box
                            className={`${classes.verticalCardContents} ${
                                classes.verticalCardContentsNoMargin
                            } ${
                                activeCard ===
                                    FILTER_STATUS.INPROGRESS_TRANSACTIONS &&
                                classes.verticalCardContentsActive
                            }`}
                            onClick={() => {
                                setActiveCard('INPROGRESS_TRANSACTIONS');
                                getListingDataWithFilterParam('IN_PROGRESS');
                            }}
                        >
                            <Typography className={classes.cardHeader}>
                                In Progress Transactions
                            </Typography>
                            <Typography className={classes.cardSubHeader}>
                                {user?.zappay?.listingData
                                    ?.inProgressTransactions ?? 0}
                            </Typography>
                        </Box>
                    </Box>
                    <AllPaymentIndentsListContainer
                        permissions={permissions}
                        sparklineFilteredlistingData={filteredListingData}
                        searchValue={searchedValue}
                        onFilterApplied={fetchListingData}
                        // listingData={paymentIndentListingData}
                    />
                </Paper>
            ) : (
                !loading && (
                    <Box
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    ></Box>
                )
            )}
            {paymentModalOpen && (
                <UploadPaymentModal
                    source="zappay"
                    enumType="payment"
                    open={paymentModalOpen}
                    onClose={() => {
                        // console.log('Closed');
                        setPaymentModalOpen(false);
                    }}
                />
            )}
            {brokerSwitchModalOpen && (
                <ConfirmModal
                    open={brokerSwitchModalOpen}
                    onClose={() => setBrokerSwitchModalOpen(false)}
                    confirmationText={`switch ${activeSourceSystem?.name}'s payment vendor from ${formatBrokerLabel(activeBroker)} to ${formatBrokerLabel(otherBroker)}`}
                    onAction={handleSwitchBroker}
                />
            )}
        </Spinner>
    );
}

const mapStateToProps = (state) => ({
    user: state?.user,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchAppConfig: (onSuccess, onError) =>
        dispatch(fetchAppConfig(onSuccess, onError)),

    dispatchGetAllPaymentIndentsListingData: (data, onSuccess, onError) =>
        dispatch(getAllPaymentIndentsListingData(data, onSuccess, onError)),

    dispatchSetFilterModalConfig: (data, onSuccess, onError) =>
        dispatch(setFilterModalConfig(data, onSuccess, onError)),

    dispatchGetSourceSystemsList: (data, onSuccess, onError) =>
        dispatch(getSourceSystemsList(data, onSuccess, onError)),

    dispatchSetBulkReleaseFlag: (data) => dispatch(setBulkReleaseFlag(data)),

    dispatchSetSelectedPaymentData: (data) =>
        dispatch(setSelectedPayments(data)),

    dispatchSetIgnoreDateFilter: (data, onSuccess, onError) =>
        dispatch(setIgnoreDateFilter(data, onSuccess, onError)),

    dispatchGetPaymentBroker: (data, onSuccess, onError) =>
        dispatch(getPaymentBroker(data, onSuccess, onError)),

    dispatchUpdatePaymentBroker: (data, onSuccess, onError) =>
        dispatch(updatePaymentBroker(data, onSuccess, onError)),

    dispatchGetAxisBankBalance: (onSuccess, onError) =>
        dispatch(getAxisBankBalance(null, onSuccess, onError)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayOnline);
